import React, { useState } from "react";
import baseURL from "./baseURL/BaseURL";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { authSliceActions } from "../../redux/slices/authSlice";
const OTPsetter = () => {
  const [otp, setOTP] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userEmail = useSelector((store) => store.authSlice.getEmail);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await baseURL.post("/otp/verify", {
        email: userEmail,
        otp_code: otp,
      });
      if (response.status === 200) {
        dispatch(authSliceActions.getRole(response.data.user.role));
        const { token } = response.data;
        localStorage.setItem("authToken", token);
        toast.success("OTP Verified Successfully!");
        setTimeout(() => {
          navigate("/");
          window.location.reload();
        }, 2000);
      } else {
        toast.error(`Unexpected success status: ${response.status}`);
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.error ||
        "Failed to verify OTP. Please try again.";
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await baseURL.post("/otp/send", { email: userEmail });
      if (response.status === 200) {
        toast.success("OTP Resent Successfully!");
      } else {
        toast.error(`Unexpected response: ${response.status}`);
      }
    } catch (error) {
      const errorMsg = error.code || "Failed to resend OTP. Please try again.";
      toast.error(errorMsg);
    }
  };
  return (
    <>
      <ToastContainer />
      <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4 py-8 font-serif">
        <div className="bg-white shadow-xl rounded-xl w-full max-w-md p-8 space-y-6">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-2 font-serif">
              Verify OTP
            </h2>
            <p className="text-gray-500">Enter your 6-digit OTP</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              value={otp}
              onChange={(e) => setOTP(e.target.value)}
              placeholder="Enter 6-digit OTP"
              maxLength={6}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none transition duration-300"
              disabled={isLoading}
            />

            <button
              type="submit"
              className="w-full bg-[#730000] text-white py-2 rounded-md hover:bg-[#730000] transition duration-300"
              disabled={isLoading}
            >
              {isLoading ? "Verifying..." : "Verify OTP"}
            </button>

            <div className="text-center text-sm text-gray-600">
              <p>
                Didn't receive OTP?{" "}
                <span
                  className="text-blue-600 cursor-pointer hover:underline"
                  onClick={handleResendSubmit}
                >
                  Resend
                </span>
              </p>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default OTPsetter;
